import { render, staticRenderFns } from "./ConductasDelDesafio.vue?vue&type=template&id=3a13af0a"
import script from "./ConductasDelDesafio.vue?vue&type=script&lang=js"
export * from "./ConductasDelDesafio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports